<template>
  <div style="supplier-bank">
    <van-popup v-model="show" :overlay="false" position="top" :style="{ height: '100%'}" :lock-scroll="true" :closeable="true" @close="close">
      <div style="height:40px;text-align:center;font-size:16px;line-height:36px;color:#EE7700">添加供应商收款账号</div>
      <van-form @submit="onSubmit" ref="sBankForm">
        <van-field v-model="SupplierId" name="SupplierId" style="display:none"/>
        <van-field required v-model="SupplierName" name="SupplierName" label="供应商名称" readonly/>
        <van-field required v-model="Account" name="Account" label="Beneficiry Namer" label-width="130" placeholder="请输入账户名称" :rules="[{ required: true, message: '请填写账户名称' }]" />
        <van-field required v-model="AccountName" name="AccountName" label="Account Number" label-width="130" placeholder="请输入银行账号" :rules="[{ required: true, message: '请填写银行账号' }]" />
        <van-field required v-model="BankName" name="BankName" label="Bank Name" placeholder="请输入银行名称" :rules="[{ required: true, message: '请填写银行名称' }]" />
        <van-field required v-model="Address" name="Address" label="Bank Address" placeholder="请输入银行地址" :rules="[{ required: true, message: '请填写银行地址' }]" />
        <van-field required v-model="SwiftCode" name="SwiftCode" label="Swift Code" placeholder="请输入银行代码" :rules="[{ required: true, message: '请填写银行代码' }]" />
        <van-field label-width="80"  v-model="AreaType" name="AreaType" label="区域"  :rules="[{ required: true, message: '请选择区域' }]" >
        <template #input>
          <van-radio-group v-model="AreaType" direction="horizontal" checked-color="#ee7700">
            <van-radio :name="1">香港境内</van-radio>
            <van-radio :name="2">香港境外</van-radio>
          </van-radio-group>
        </template>
        </van-field>
        <van-field label-width="80"  v-model="CurrencyType" name="CurrencyType" label="币种"  :rules="[{ required: true, message: '请选择币种' }]" >
        <template #input>
          <van-radio-group v-model="CurrencyType" direction="horizontal" checked-color="#ee7700">
            <van-radio :name="1">不限币种</van-radio>
            <van-radio :name="2">USD</van-radio>
            <van-radio :name="3">HKD</van-radio>
          </van-radio-group>
        </template>
        </van-field>
        
        <van-button round block type="info" native-type="submit" style="margin-top:40px;background-color:#EE7700;border:none;" >提交</van-button>
      </van-form>
    </van-popup>
  </div>
</template>

<script>
import { addSupplierBank } from "~/api/supplierBank";

const currencyTypeToStr = { 1: "ANY", 2: "USD", 3: "HKD" };
export default {
  name: "AddView",
  components: {
  },
  data() {
    return {
      AccountName:"",
      BankName:"",
      SwiftCode:"",
      Address:"",
      Account:"",
      AreaType:"",
      CurrencyType:""
    };
  },

  props: {
    show: Boolean,
    SupplierId:Number,
    SupplierName:String
  },

  methods: {
    async onSubmit(data){
      try{
        data.CurrencyType=currencyTypeToStr[data.CurrencyType];
        const res = await addSupplierBank(data);
        this.$emit("supplierBankCb",{BankInfo:data,BankId:res})
      }catch{
        Toast.fail("操作失败，请重试！");
      }
    },

    async close(){
      this.$emit("supplierBankCb",null)
    }
  },

  watch:{
    show:{
      handler(v){
        if(v){
          this.$refs.sBankForm.resetValidation("");
        }
      }
    }
  }
};
</script>

<style lang="scss" scope>

</style>
